import { ReportProfileAlertDeleteResourceModel } from '../../../profile/report-profile-alert-delete-resource-model';
import { SharePointSiteReportProfile } from '../../../microsoft/onedrive/profile/share-point-site-report-profile';

export class SharePointReportProfileAlertDeleteResourceModel extends ReportProfileAlertDeleteResourceModel {
  deleteSite: boolean;
  site: SharePointSiteReportProfile;
}
